/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Navbar_Nav_NexyInputs */

const es_navbar_nav_nexy = /** @type {(inputs: Navbar_Nav_NexyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexy`)
};

const en_navbar_nav_nexy = /** @type {(inputs: Navbar_Nav_NexyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexy`)
};

/**
* | output |
* | --- |
* | "Nexy" |
*
* @param {Navbar_Nav_NexyInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const navbar_nav_nexy = /** @type {((inputs?: Navbar_Nav_NexyInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Navbar_Nav_NexyInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_navbar_nav_nexy(inputs)
	return en_navbar_nav_nexy(inputs)
});
export { navbar_nav_nexy as "navbar.nav_nexy" }